var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwapArrow2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 8,
    viewBox: "0 0 147 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.146447 3.39645C-0.0488155 3.59171 -0.0488155 3.90829 0.146447 4.10355L3.32843 7.28553C3.52369 7.4808 3.84027 7.4808 4.03553 7.28553C4.2308 7.09027 4.2308 6.77369 4.03553 6.57843L1.20711 3.75L4.03553 0.921573C4.2308 0.726311 4.2308 0.409728 4.03553 0.214466C3.84027 0.0192039 3.52369 0.0192039 3.32843 0.214466L0.146447 3.39645ZM146.854 4.10355C147.049 3.90829 147.049 3.59171 146.854 3.39645L143.672 0.214466C143.476 0.0192039 143.16 0.0192039 142.964 0.214466C142.769 0.409728 142.769 0.726311 142.964 0.921573L145.793 3.75L142.964 6.57843C142.769 6.77369 142.769 7.09027 142.964 7.28553C143.16 7.4808 143.476 7.4808 143.672 7.28553L146.854 4.10355ZM0.5 3.75V4.25H146.5V3.75V3.25H0.5V3.75Z",
    fill: "#8A8A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapArrow2);
export default __webpack_public_path__ + "static/media/swap-arrow-2.2589dfd96db7d1376e9463b124fc9743.svg";
export { ForwardRef as ReactComponent };